import {
  UPDATE_DESIGN,
  UPDATE_LAYOUT,
  UPDATE_TEXTS,
  UPDATE_BEHAVIOUR,
} from '../actions';

export const editorSettingsDesign = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_DESIGN: {
      return { ...state, ...action.design };
    }
    default:
      return state;
  }
};

export const editorSettingsLayout = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_LAYOUT: {
      return { ...state, ...action.layout };
    }
    default:
      return state;
  }
};

export const editorSettingsTexts = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_TEXTS: {
      return { ...state, ...action.texts };
    }
    default:
      return state;
  }
};

export const editorSettingsBehaviour = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_BEHAVIOUR: {
      return { ...state, ...action.behaviour };
    }
    default:
      return state;
  }
};
